import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import { apiFetch } from 'api';
import useIsMobile from "hooks/isMobile";

const roundScoreHeaders = [
    { key: "player",     value: "Spelare" },
    { key: "points",     value: "Poäng" },
    { key: "netScore",   value: "Netto" },
    { key: "grossScore", value: "Brutto" },
    { key: "birdies",    value: "Birdies" },
    { key: "eagles",     value: "Eagles" },
    { key: "prizeMoney", value: "Pengar inspelat" },
];

const hiddenOnMobile = ["eagles", "grossScore"];

export default function Rounds() {
    const { leagueId } = useParams();
    const isMobile = useIsMobile();

    const [rounds, setRounds] = useState([]);
    const [openRounds, setOpenRounds] = useState([]);

    useEffect(() => {
        apiFetch(`/league/${leagueId}/rounds`)
            .then(r => r.json())
            .then(data => setRounds(data || []))
            .catch(console.error);
    }, [leagueId]);

    const toggleRound = (index) => {
        setOpenRounds(prev =>
            prev.includes(index) ? prev.filter(i => i !== index) : [...prev, index]
        );
    };

    const visibleScoreHeaders = isMobile
        ? roundScoreHeaders.filter(h => !hiddenOnMobile.includes(h.key))
        : roundScoreHeaders;

    return (
        <div>
            <table className="table rounds-table">
                <thead>
                    <tr>
                        <th>DATUM</th>
                        <th>BANA</th>
                        <th>VINNARE</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {rounds.map((round, index) => {
                        const isOpen = openRounds.includes(index);
                        const winner = round.playerScores?.length > 0
                            ? round.playerScores.reduce((max, p) =>
                                (p.prizeMoney || 0) > (max.prizeMoney || 0) ? p : max,
                                round.playerScores[0])
                            : null;

                        return (
                            <React.Fragment key={index}>
                                <tr
                                    className={`round-wrapper ${isOpen ? "open" : ""} ${round.signatureEvent ? "signature-event" : ""}`}
                                    onClick={() => toggleRound(index)}
                                >
                                    <td>{round.date}</td>
                                    <td>
                                        <p className="bold">{round.club}</p>
                                        <p>
                                            <span className="bold">{round.course}</span>
                                            {" - "}
                                            <span>{round.tee}</span>
                                        </p>
                                    </td>
                                    {winner ? (
                                        <>
                                            <td>{winner.firstName} {winner.lastName}</td>
                                            <td>
                                                {round.eventName ? (
                                                    <p>{round.eventName}</p>
                                                ) : round.signatureEvent ? (
                                                    <p className="signature-event-text">{round.signatureEventName}</p>
                                                ) : null}
                                                <p>{winner.prizeMoney} kr</p>
                                            </td>
                                        </>
                                    ) : (
                                        <td colSpan={2}>Inga spelare</td>
                                    )}
                                </tr>

                                {isOpen && (
                                    <tr className="round-details">
                                        <td colSpan={4}>
                                            <table className="score-table">
                                                <thead>
                                                    <tr>
                                                        {visibleScoreHeaders.map(h => (
                                                            <th key={h.key}>{h.value}</th>
                                                        ))}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {[...round.playerScores].sort((a, b) => {
                                                        const aPos = a.roundPosition ?? null;
                                                        const bPos = b.roundPosition ?? null;
                                                        if (aPos !== null && bPos !== null) return aPos - bPos;
                                                        if (aPos !== null) return -1;
                                                        if (bPos !== null) return 1;
                                                        const netDiff = Number(a.netScore || 0) - Number(b.netScore || 0);
                                                        if (netDiff !== 0) return netDiff;
                                                        return Number(a.hcp || 0) - Number(b.hcp || 0);
                                                    }).map((ps, i) => (
                                                        <tr key={i}>
                                                            {visibleScoreHeaders.map(h => (
                                                                <td key={h.key}>
                                                                    {h.key === "player"
                                                                        ? `${ps.firstName} ${ps.lastName}`
                                                                        : ps[h.key]}
                                                                </td>
                                                            ))}
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                )}
                            </React.Fragment>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
}
